import styled from 'styled-components';

export const StyledPillText = styled.p`
  ${props => props.theme.typography.body}
  ${props => props.theme.fontFamily.condensed}
  background-color: ${props =>
    props.variant === 'light'
      ? props.theme.colors.neutral.bone
      : props.theme.colors.neutral.darkerFur};
  border-radius: 500px;
  color: ${props =>
    props.variant === 'light'
      ? props.theme.colors.text.secondary
      : props.theme.colors.text.lightest};
  padding: ${props => props.theme.spacing(0, 4)};
  text-transform: uppercase;
  width: max-content;
`;
